import React from "react";
import { AlertTriangle, RotateCcw } from "lucide-react";

export default class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError() {
    return { hasError: true };
  }

  componentDidCatch(error, info) {
    // eslint-disable-next-line no-console
    console.error("UI error:", error, info);
  }

  render() {
    if (this.state.hasError) {
      return (
        <div className="min-h-screen grid place-items-center bg-background text-foreground px-6" data-testid="error-boundary">
          <div className="max-w-md w-full border border-border bg-card p-8 text-center">
            <div className="w-12 h-12 mx-auto grid place-items-center border border-brand bg-brand/10 mb-5">
              <AlertTriangle className="w-5 h-5 text-brand" />
            </div>
            <h1 className="font-serif text-2xl font-semibold">Something went wrong</h1>
            <p className="text-muted-foreground text-sm mt-2">
              An unexpected error occurred while rendering this page. Reloading usually fixes it.
            </p>
            <button
              onClick={() => window.location.reload()}
              className="mt-6 inline-flex items-center gap-2 bg-primary text-primary-foreground px-5 py-2.5 text-sm hover:opacity-90 transition-opacity"
              data-testid="error-reload-btn"
            >
              <RotateCcw className="w-4 h-4" /> Reload page
            </button>
          </div>
        </div>
      );
    }
    return this.props.children;
  }
}
